import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Branch from '../components/branch';
import { fetchBranch } from '../store/actions/branch';
import { openExportDialog, closeExportDialog, cancelExportDialog } from '../store/actions/fileexport';
import { compose, lifecycle } from 'recompose';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state, ownProps) => {

    return {
        mobile: state.browser.lessThan.medium,
        salesByDate: state.branchPage.branch?state.branchPage.branch.salesByDate:null,
        denominationDetails: state.branchPage.branch?state.branchPage.branch.denominationDetails:null,
        ...state.branchPage,
        branchId: ownProps.match.params.branchId,
        loaded: state.branchPage.branch !== null,
        loading: state.branchPage.loading,
        exportDialog: {...state.fileexport},
        onOperatorsClick: ()=>{
            ownProps.history.push(`/customers/${ownProps.match.params.customerId}/${ownProps.match.params.branchId}/operators`)
        },
        showMap: ()=> {
            ownProps.history.push(`/customers/${ownProps.match.params.customerId}/${ownProps.match.params.branchId}/map`)
        },
        openTransactionDay: (index) => {
            let selectedTransactionDay = state.branchPage.branch.transactionDayDTOList[index];
            ownProps.history.push(`/customers/${ownProps.match.params.customerId}/${ownProps.match.params.branchId}/transactions/${selectedTransactionDay.day}`)
        },
        openTransactionDayPick: (day) => {
            ownProps.history.push(`/customers/${ownProps.match.params.customerId}/${ownProps.match.params.branchId}/transactions/${day}`)
        }
    };
};


const mapDispatchToProps = (dispatch, ownProps) => {
    const branchId = ownProps.match.params.branchId;

    return {
        fetchBranch: () => dispatch(fetchBranch(branchId)),
        //fetchBranchTransactions: () => dispatch(fetchBranchTransactions(branchId)),
        openExportDialog: () => dispatch(openExportDialog()),
        closeExportDialog: (range) => dispatch(closeExportDialog(range)),
        cancelExportDialog: () => dispatch(cancelExportDialog())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchBranch();
        //this.props.fetchBranchTransactions();
    },
    componentDidUpdate() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(Branch);






// WEBPACK FOOTER //
// ./src/containers/BranchContainer.js